<div class="marquee-container">
  <div class="marquee-text">{{ marqueeText }}</div>
</div>


